import { MagicLinkLoginPage } from './MagicLinkLoginPage';

export function PartnerLoginPage() {
  return <MagicLinkLoginPage persona="partner" />;
}

export default PartnerLoginPage;
